module.exports = "/_next/static/festival-rw.css?3SbGs-7";